import Grid from "@mui/material/Grid";
import EarningsChart from "./EarningsChart";
import UsageChart from "./UsageChart";
import SignUpTrends from "./SignUpTrends";

function Charts({ data }) {
  const earnings = data?.earnings;

  console.log("Charts wrapper — earnings keys:", earnings ? Object.keys(earnings) : "NO earnings");
  console.log("Charts wrapper — byYear keys:", earnings?.byYear ? Object.keys(earnings.byYear) : "NO byYear");

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <EarningsChart data={{ earnings }} />
      </Grid>

      <Grid item xs={12} md={4}>
        <UsageChart data={{ earnings }} />
      </Grid>

      <Grid item xs={12} md={4}>
        <SignUpTrends data={{ earnings }} />
      </Grid>
    </Grid>
  );
}

export default Charts;